import React, { useState, useCallback } from "react";
import {
    Grid,
    Box,
    Container,
    Typography,
    Button,
    Card,
    CardContent,
    Paper,
    Stack,
    Pagination,
} from "@mui/material";

import { ReactComponent as PeopleIcon } from "../../assets/icons/Network-Users--Streamline-Ultimate.svg";

import ParticipantList from "./ParticipantsList";
import LdsMap from "./LdsMap";
import { URL_REGISTRY } from "../../config/settings";
import { useTranslator } from "../../context/TranslatorContext";
import ParticipantsFilters from "./ParticipantsFilters";

export default function ParticipantsDashboard() {
    const { messages } = useTranslator();
    const [participantData, setParticipantData] = useState([]);
    const [facets, setFacets] = useState({});
    const [country, setCountry] = useState("");
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [activeSearch, setActiveSearch] = useState("");
    const [euRegistered, setEuRegistered] = useState(false);
    const [euControlled, setEuControlled] = useState(false);
    const [sortField, setSortField] = useState("participant");
    const [sortOrder, setSortOrder] = useState("Asc");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const handleReset = () => {
        setSearchQuery("");
        setActiveSearch("");
        setEuRegistered(false);
        setEuControlled(false);
        setCountry("");
        setPage(1);
        setSortField("participant");
        setSortOrder("Asc");
        setSelectedCountry(null);
    };

    const handleParticipantData = useCallback(
        ({participants, facets, totalPages}) => {
            setParticipantData(participants);
            setFacets(facets);
            if (totalPages) setTotalPages(totalPages);
        },
        []
    );

    const handlePageChange = (event, value) => {
        setPage(value);
    };
    // console.log(totalPages);
    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Box component="section" sx={{ pt: 2, pb: 2 }}>
                {/* <div style={{ margin: "1em" }}>
                    <Alert severity="info">{messages.updateBannerText}</Alert>
                </div> */}
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 3,
                        border: "1px solid",
                        borderColor: "#D6E6F7",
                        background: "#F4F8FD",
                        overflow: "hidden",
                    }}
                >
                    <CardContent>
                        <Stack direction={{ xs: "column", sm: "row" }}
                            spacing={1.5}
                            alignItems={{ xs: "flex-start", sm: "center" }}
                        >
                            <Box
                                sx={{
                                    flexShrink: 0,
                                    width: 76,
                                    height: 76,
                                    borderRadius: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#eef2f6",
                                    color: "#0F2651",
                                }}
                            >
                                <PeopleIcon style={{ width: 52, height: 52 }} />
                            </Box>

                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "#0F2651",
                                        fontWeight: 700,
                                        mb: 0.5,
                                    }}
                                >
                                    {messages.joinTitle}
                                </Typography>

                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "rgba(0, 0, 46, 0.82)",
                                        mb: 2,
                                        lineHeight: 1.6,
                                    }}
                                >
                                    {messages.participantsHelpText}
                                </Typography>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => window.open(URL_REGISTRY, "_blank")}
                                    sx={{
                                        minWidth: { xs: "100%", sm: 200 },
                                        alignSelf: "flex-start",
                                        px: 3,
                                        borderRadius: 2,
                                        boxShadow: "none",
                                    }}
                                >
                                    {messages.joinButton}
                                </Button>
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>

            <Paper variant="outlined" sx={{ p: 4, mb: 4, borderRadius: 3, borderColor: "divider", backgroundColor: "background.paper", boxShadow: "none",}}>
                <Stack spacing={2}>
                    <ParticipantsFilters
                        participantData={participantData}
                        facets={facets}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        setActiveSearch={setActiveSearch}
                        euRegistered={euRegistered}
                        setEuRegistered={setEuRegistered}
                        euControlled={euControlled}
                        setEuControlled={setEuControlled}
                        country={country}
                        setCountry={setCountry}
                        sortOrder={sortOrder}
                        setSortOrder={setSortOrder}
                        onReset={handleReset}
                    />
                </Stack>
            </Paper>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <ParticipantList
                        search={activeSearch}
                        euRegistered={euRegistered}
                        euControlled={euControlled}
                        country={country}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        selectedCountry={selectedCountry}
                        onCountryHover={setSelectedCountry}
                        onDataLoad={handleParticipantData}
                        page={page}
                    />

                    {totalPages > 1 && (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 2 }}>
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                color="primary"
                            />
                        </Box>
                    )}
                </Grid>
                <Grid item xs={12} md={8} sx={{height: "70vh"}}>
                    <LdsMap
                        participantData={participantData}
                        selectedCountry={selectedCountry}
                        onCountryClick={setSelectedCountry}
                    />
                </Grid>
            </Grid>
        </Container>

    );

}
